import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ReactModal from 'react-modal';

import {submitInvite as submit, cancelInvite as cancel} from 'flows/deal/invite/index';
import {selectShowInvite as selectShow, selectInviteSending as selectSending} from 'flows/deal/invite/reducer'

import SendInvite from './component';

export const SendInviteContainer = ({show, submit, cancel, sending}) => (
  <ReactModal
    isOpen={show}
    contentLabel="Send Invite"
    shouldCloseOnOverlayClick
    className="ReactModal"
  >
    <SendInvite submit={submit} cancel={cancel} sending={sending} />
  </ReactModal>

);

SendInviteContainer.propTypes = {
  show: PropTypes.bool.isRequired,
  sending: PropTypes.bool.isRequired,
  submit: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
};

export const mapStore = store => ({
  show: selectShow(store),
  sending: selectSending(store),
});

export default connect(mapStore, {cancel, submit})(SendInviteContainer);



// WEBPACK FOOTER //
// ./web/flows/deal/invite/index.js